import { Image } from 'antd';
import React from 'react';
import PictureFail from '../static/picture-fail.png';
import CustomMask from './CustomMask';

const Image360 = (props) => {
  const { previewStyle = {}, ...remaining } = props;
  return (
    <Image
      fallback={PictureFail}
      preview={{ mask: <CustomMask />, ...previewStyle }}
      wrapperStyle={{ width: '100%', display: 'block' }}
      {...remaining}
    />
  );
};
export default Image360;
